/**
 * Extending jQuery
 */
export default () => {

  /**
   * Create :focusable selector for jQuery
   *
   * @examples
   * $(:focusable).on('focus', () => { ... });
   * $(.element > :focusable).on('focus', () => { ... });
   * $variable.find(':focusable').on('focus', () => { ... });
   *
   */
  $.extend($.expr[':'], {
    focusable(el) {
      return $(el).is('a, button, :input, [tabindex]');
    }
  });

  $.fn.extend({
    isSticky(options) {
      const defaults = {
        element: $(this),
        breakpoint: 0,
        class: '',
        id: '',
        zIndex: '',
        stopper: '',
        stuckClass: '-stuck'
      };
      const settings = $.extend({}, defaults, options);

      let pastBreakpoint = false;

      // Where we want it to start being sticky
      let stickyPoint = settings.element.offset().top;

      // Elements width
      let thisWidth = settings.element.parent().outerWidth();

      // Cache a clone sticky element
      const placeholder = $('<div class="js-sticky-placeholder" style="display: none;"></div>').width(thisWidth).height(settings.element.outerHeight());

      // Add class(es) if specified
      if (settings.class) {
        placeholder.addClass(settings.class);
      }

      // Add id if specified
      if (settings.id) {
        placeholder.attr('id', settings.id);
      }

      // Checks if stopper was defined
      settings.hasStopper = function() {
        return 0 < $(this.stopper).length || typeof this.stopper === 'number' ? true : false;
      };

      // Sets position fixed vs static
      settings.setPosition = function(data) {
        return data.isStuck ? 'fixed' : '';
      };

      // Sets top position
      settings.setTop = function(data) {
        const stopPoint = settings.hasStopper ? $(this.stopper).offset().top - this.element.outerHeight() : 0;

        if (stickyPoint < data.windowTop) {
          if (settings.hasStopper && stopPoint < data.windowTop) {
            return stopPoint - data.windowTop;
          }
          return 0;
        }
        return '';
      };

      // Sets element's width when stuck
      settings.setWidth = function(data) {

        if (data.event.type === 'resize') {

          // Re-calculate width
          thisWidth = settings.element.parent().outerWidth();

          // Reset width/height of placeholder
          placeholder.width(thisWidth).height(settings.element.outerHeight());
        }

        return data.isStuck ? thisWidth : '';
      };

      // Sets element's z-index when stuck
      settings.setIndex = function(data) {
        return typeof this.zIndex === 'number' && data.isStuck ? this.zIndex : '';
      };

      // Applies position, top, width and z-index when stuck.
      // Sets element's class when stuck or unstuck.
      // Hides or unhides placeholder element when stuck or unstuck.

      // Resets CSS of element
      settings.resetCSS = function() {
        return this.element.css({
          'position': '',
          'top': '',
          'width': '',
          'z-index': ''
        });
      };

      settings.stickyScroll = function(e) {
        if (e.type === 'resize') {
          // On resize, we need to check if the sticky point has changed
          settings.resetCSS();
          stickyPoint = settings.element.offset().top;
          pastBreakpoint = $(window).width() >= settings.breakpoint;
        }

        if (!pastBreakpoint) {
          return;
        }

        const data = {
          event: e,
          windowTop: $(window).scrollTop()
        };
        data.isStuck = stickyPoint < data.windowTop;

        settings.element.css({
          'position': settings.setPosition(data),
          'top': settings.setTop(data),
          'width': settings.setWidth(data),
          'z-index': settings.setIndex(data)
        });

        if (data.isStuck) {
          settings.element.addClass(settings.stuckClass);
          placeholder.css('display', '');
        } else {
          settings.element.removeClass(settings.stuckClass);
          placeholder.css('display', 'none');
        }
      };

      // Initializes the sticky placeholder element and binds listener
      settings.init = function() {
        if ($(window).innerHeight() > this.element.outerHeight()) {
          settings.element.after(placeholder);

          pastBreakpoint = $(window).width() >= settings.breakpoint;

          $(window).on('scroll load resize', this.stickyScroll);
        }
      };

      // Removes event binding for sticky function, removes placeholder, and resets CSS of element
      settings.destroy = function() {
        $(window).off('scroll load resize', this.stickyScroll);
        settings.resetCSS();
        placeholder.remove();
      };

      return settings;
    }
  });

};
